import React, { useState } from 'react'
import {
  Button,
  Card,
  Divider,
  Popconfirm,
  Table
} from 'antd'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import DocumnetForm from './components/DocumentsForm'
import {
  createDocument,
  deleteDocument,
  fetchDocumentList,
  updateDocument
} from '../../modules/document'
import _ from 'lodash'

const Document = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { docList ,isLoading } = useSelector(
    (state) => ({
      docList: state.document.docList,
      isLoading: state.document.isLoading
    }),
    []
  )
  
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchDocumentList())
    }

    fetch()
  }, [])

  const columns = [
    {
      title: 'Document Name',
      dataIndex: 'name',
      key: 'name',
      render: (name) => (
        <div>
          {name} 
        </div>
      )
    },
    {
      title: 'Detail',
      key: 'detail',
      dataIndex: 'detail',
      render: (detail) => <span style={{whiteSpace: "pre-wrap"}}>{detail}</span>
    },
    {
      title: 'Example file',
      key: 'image',
      dataIndex: 'image',
      render: (image) => <span>            <img
      src={image}
      width={200}
      height={200}
      style={{ marginRight: 10, objectFit: 'cover' }}
      alt="img"
    /></span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.docId)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchDocumentList())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateDocument(data))
    } else {
      await dispatch(createDocument(data))
    }

    await dispatch(fetchDocumentList())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteDocument(id))
    await dispatch(fetchDocumentList())
  }

  const refetchData = async () => {}


  return (
    <Card
      title="Document"
      extra={
        <div>
           <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New Document
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button> 
        </div>
      }>
      <br />
      <Table
        loading={isLoading}
        bordered
        dataSource={docList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <DocumnetForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default compose(withApollo)(Document)
